export const arrowDoubleLeftIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" stroke-width="1.5" viewBox="-0.75 -0.75 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10.958 21.797.909 11.747a.7.7 0 0 1 0-.994L10.958.703m10.547 21.094-10.049-10.05a.7.7 0 0 1 0-.994L21.505.703"/></svg>`,
    name: 'arrow-double-left' as const
};